import { Box } from '@mui/material'

import Color from '@ecm/ui/element/Color'

type GradientBoxProps = {
  children: React.ReactNode
} & Omit<React.ComponentProps<typeof Box>, 'sx'>

const GradientBox = ({ children, ...otherProps }: GradientBoxProps) => (
  <Box
    m="0 auto"
    p={{ lg: '2.5em 2em', xs: '2.5em' }}
    borderRadius="8px"
    maxWidth="850px"
    boxSizing="border-box"
    sx={{
      '.MuiTypography-root': {
        color: Color.white.normal,
      },
      background: 'linear-gradient(94.72deg, #0F2272 0%, #0088BA 59.25%, #4EDF97 92.83%)',
    }}
    {...otherProps}
  >
    {children}
  </Box>
)

export default GradientBox
